/**
 * Halftone Customizer Controller
 * Extracted from halftone_image.liquid for better maintainability.
 *
 * v4.0 (KARVA, 2026-10) - Preisstufen + Shopify-Datei-Upload, kein externer Server mehr
 * - Preis kommt aus Varianten mit SKU "TIER-<max. Fläche in cm²>" (window.karvaTiers)
 * - Linienbild und Originalfoto werden per FormData direkt an die Warenkorb-Position gehängt
 * - Ghost-Varianten und Cloudflare Worker werden nicht mehr verwendet
 *
 * v3.0 - Ghost Variant Preisberechnung
 * - Preis wird per Formel berechnet: (Fläche × 0.02 + 20) × 1.19
 * - Ghost Variant wird via Cloudflare Worker erstellt (exakter Preis)
 * - Kein Tier-System mehr — exakte Formel-Preise im Checkout
 *
 * v2.1 - Base64 Bild-Upload für Warenkorb
 * - Bild wird als Base64 Data-URL in Cart-Property gespeichert
 * - Automatische Komprimierung wenn Bild zu groß (>250KB)
 * - Bild wird im Warenkorb als Vorschau angezeigt
 */

(function () {
  'use strict';

  function init() {
    if (typeof $ === 'undefined' || typeof RasterPro === 'undefined') {
      setTimeout(init, 50);
      return;
    }

    $(document).ready(function () {
      // Preisformel: (Fläche × pricePerCm2 + basePriceNet) × (1 + vatRate/100)
      // Werte aus Theme-Settings (Shopify Admin), Fallback auf Defaults
      const themeSettings = window.halftoneThemeSettings || {};
      const PRICE_PER_CM2 = themeSettings.pricePerCm2 ?? 0.02;
      const BASE_PRICE_NET = themeSettings.basePriceNet ?? 20;
      const VAT_RATE = (themeSettings.vatRate ?? 19) / 100;

      /**
       * Berechnet den Brutto-Preis aus Breite × Höhe
       * @param {number} w - Breite in cm
       * @param {number} h - Höhe in cm
       * @returns {number} - Preis in EUR (2 Dezimalstellen)
       */
      // v4: Preisstufen nach Fläche. Jede Stufe ist eine Variante mit SKU "TIER-<max cm²>",
      // window.karvaTiers wird in halftone_image.liquid aus den Varianten erzeugt.
      const TIERS = (window.karvaTiers || []).slice().sort(function (a, b) { return a.max - b.max; });
      console.log('[Halftone v4] Preisstufen geladen:', TIERS.length);

      function findTier(w, h) {
        const area = w * h;
        for (let i = 0; i < TIERS.length; i++) {
          if (area <= TIERS[i].max + 0.0001) return TIERS[i];
        }
        return TIERS.length ? TIERS[TIERS.length - 1] : null;
      }

      function calculateFormulaPrice(w, h) {
        const tier = findTier(w, h);
        return tier ? tier.price / 100 : 0;
      }

      // Basis-Variante (wird beim Ghost-Variant-Flow durch Worker-Variante ersetzt)
      let currentVariantId = $('#product_variant_id').val();

      // Initialization
      const image = new Image();
      image.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'; // Placeholder
      image.setAttribute('crossOrigin', 'anonymous');

      // CG-PREVIEW: themeSettings already declared above (line 28) from Liquid bridge
      console.log('[Halftone] Initializing with theme settings:', themeSettings);

      window.halftone_image = new RasterPro('raster_pro_wrapper', {
        SOURCE_IMAGE: image,
        RASTER_TYPE: themeSettings.rasterType || 'line',
        RASTER_ANGLE: themeSettings.rasterAngle || 30,
        DOT_SIZE: themeSettings.dotSize || 10,
        LINE_SMOOTHING: themeSettings.smoothing || 3,
        CANVAS_COLOR: themeSettings.canvasColor || '#ffffff',
        DOT_COLOR: themeSettings.dotColor || '#000000',
        CANVAS_WIDTH: 755,
        CANVAS_HEIGHT: 1133,
        BRIGHTNESS: 0.5,
        CONTRAST: 0.5,
        SHOW_RENDERING_PROGRESS: false,
        USE_PRELOADER: false,
      });

      /**
       * Shopify Theme Editor: Demo-Bild für Settings-Preview
       * Wenn der Theme Editor aktiv ist, wird ein programmatisch erzeugtes
       * Graustufen-Bild geladen, damit Raster-Typ, Winkel und Farben sofort
       * sichtbar sind – ohne dass der User ein Bild hochladen muss.
       */
      if (window.Shopify && window.Shopify.designMode) {
        console.log('[Halftone] Theme Editor erkannt – lade Demo-Bild für Settings-Preview');

        const DEMO_SIZE = 600;
        const demoCanvas = document.createElement('canvas');
        demoCanvas.width = DEMO_SIZE;
        demoCanvas.height = DEMO_SIZE;
        const demoCtx = demoCanvas.getContext('2d');

        // Diagonaler Graustufen-Gradient als Demo-Inhalt
        const grad = demoCtx.createLinearGradient(0, 0, DEMO_SIZE, DEMO_SIZE);
        grad.addColorStop(0,   '#ffffff');
        grad.addColorStop(0.3, '#dddddd');
        grad.addColorStop(0.6, '#888888');
        grad.addColorStop(1,   '#111111');
        demoCtx.fillStyle = grad;
        demoCtx.fillRect(0, 0, DEMO_SIZE, DEMO_SIZE);

        // Kreismuster für Kontrast-Variation (macht Halftone-Unterschiede sichtbarer)
        demoCtx.fillStyle = 'rgba(0,0,0,0.18)';
        for (var dy = 0; dy < DEMO_SIZE; dy += 90) {
          for (var dx = 0; dx < DEMO_SIZE; dx += 90) {
            demoCtx.beginPath();
            demoCtx.arc(dx + 45, dy + 45, 28, 0, Math.PI * 2);
            demoCtx.fill();
          }
        }

        var demoImg = new Image();
        demoImg.src = demoCanvas.toDataURL();
        demoImg.onload = function () {
          if (!window.halftone_image) { return; }

          window.halftone_image.canvasWidth  = DEMO_SIZE;
          window.halftone_image.canvasHeight = DEMO_SIZE;
          window.halftone_image.sourceImage  = demoImg;
          // Mindest-Dot-Size für sichtbaren Preview (dot_size=1.5 wäre sonst unsichtbar)
          window.halftone_image.dotSize = Math.max(8, themeSettings.dotSize || 10);
          imageLoaded        = true;
          currentCanvasWidth  = DEMO_SIZE;
          currentCanvasHeight = DEMO_SIZE;

          // Canvas sichtbar schalten (Placeholder ausblenden)
          $('.halftone-image-placeholder').addClass('has-image');
          $('.drop_box').hide();
          $('#raster_pro_wrapper').css({ opacity: '1', visibility: 'visible', display: 'block' });

          window.halftone_image.update();

          // Canvas nach asynchronem RasterPro-Render erzwingen
          setTimeout(function () {
            $('#raster_pro_wrapper').find('canvas').each(function () {
              this.style.setProperty('display',     'block',   'important');
              this.style.setProperty('visibility',  'visible', 'important');
              this.style.setProperty('opacity',     '1',       'important');
              this.style.setProperty('position',    'relative','important');
            });
            console.log('[Halftone] Design Mode Demo geladen ✅');
          }, 300);
        };
      }

      /**
       * Calculate CNC-accurate DOT_SIZE for realistic preview
       * Based on 2mm (0.2cm) optimal line spacing for aluminum CNC
       *
       * @param {number} physicalWidthCm - Physical width in cm
       * @param {number} physicalHeightCm - Physical height in cm
       * @param {number} canvasWidthPx - Canvas width in pixels
       * @param {number} canvasHeightPx - Canvas height in pixels
       * @returns {number} - DOT_SIZE in pixels
       */
      function calculateCNCAccurateDotSize(physicalWidthCm, physicalHeightCm, canvasWidthPx, canvasHeightPx) {
        // Physical line spacing for CNC halftone (2mm = 0.2cm for aluminum)
        const TARGET_LINE_SPACING_CM = 0.2;

        // Calculate pixels per cm (how many pixels represent 1cm on the canvas)
        const pxPerCmWidth = canvasWidthPx / physicalWidthCm;
        const pxPerCmHeight = canvasHeightPx / physicalHeightCm;
        const pxPerCm = Math.min(pxPerCmWidth, pxPerCmHeight);

        // CNC-accurate DOT_SIZE: map 2mm physical line spacing to canvas pixels
        // This is a fixed physical constraint of the CNC machine, not a theme setting
        const dotSizePx = TARGET_LINE_SPACING_CM * pxPerCm;

        console.log('[Halftone CNC Preview] Physical:', physicalWidthCm, 'x', physicalHeightCm, 'cm');
        console.log('[Halftone CNC Preview] Canvas:', canvasWidthPx, 'x', canvasHeightPx, 'px');
        console.log('[Halftone CNC Preview] Pixels per cm:', pxPerCm.toFixed(2));
        console.log('[Halftone CNC Preview] DOT_SIZE (2mm CNC spacing):', dotSizePx.toFixed(2), 'px');

        return Math.max(2, Math.round(dotSizePx));
      }

      /**
       * DOT_SIZE kommt ausschließlich aus den Theme Settings.
       * Größenänderungen haben keinen Einfluss auf die Linienbreite.
       */
      function updateDotSizeForDimensions() {
        // intentionally empty – dot size is fixed by theme settings only
      }

      /**
       * Normalisiert das Quellbild auf die Canvas-Dimensionen, damit RasterPro
       * immer mit identischer Pixeldichte arbeitet — unabhängig von der Original-DPI.
       * @param {HTMLImageElement} img - Original-Bild
       * @param {number} targetWidth - Ziel-Breite (Canvas-Pixel)
       * @param {number} targetHeight - Ziel-Höhe (Canvas-Pixel)
       * @returns {Promise<HTMLImageElement>} - Normalisiertes Bild
       */
      function normalizeSourceImage(img, targetWidth, targetHeight) {
        return new Promise(function (resolve) {
          console.log('[Halftone] Normalizing source:', img.width, 'x', img.height, '->', targetWidth, 'x', targetHeight);
          var offscreen = document.createElement('canvas');
          offscreen.width = targetWidth;
          offscreen.height = targetHeight;
          var ctx = offscreen.getContext('2d');
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';
          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

          var normalizedImg = new Image();
          normalizedImg.onload = function () {
            console.log('[Halftone] Source normalized:', normalizedImg.width, 'x', normalizedImg.height);
            offscreen.width = 0;
            offscreen.height = 0;
            resolve(normalizedImg);
          };
          normalizedImg.onerror = function () {
            console.error('[Halftone] Normalization failed, using original');
            resolve(img);
          };
          normalizedImg.src = offscreen.toDataURL('image/png');
        });
      }

      /**
       * Aktualisiert den angezeigten Preis basierend auf der Formel.
       * Der exakte Preis wird beim Add-to-Cart serverseitig im Worker berechnet
       * und als Ghost-Variante erstellt — Widget und Checkout zeigen denselben Preis.
       */
      function updatePrice() {
        const w = parseFloat($('#custom-width').val()) || 40;
        const h = parseFloat($('#custom-height').val()) || 40;
        const q = parseInt($('#custom-quantity').val()) || 1;

        // State speichern fuer Add-to-Cart (verhindert DOM-Reset-Bug)
        lastWidth = w;
        lastHeight = h;

        // Preis per Formel berechnen
        const unitPrice = calculateFormulaPrice(w, h);
        const displayPrice = unitPrice * q;

        console.log('[Halftone v3] Preis:', {
          dimensions: w + 'x' + h + ' cm',
          area: (w * h) + ' cm²',
          unitPrice: unitPrice.toFixed(2) + '€',
          quantity: q,
          total: displayPrice.toFixed(2) + '€',
        });

        // UI Update
        $('#halftone-price-display').text(
          displayPrice.toLocaleString('de-DE', {
            style: 'currency',
            currency: 'EUR',
          })
        );
      }

      // Slider Throttling with requestAnimationFrame
      let ticking = false;
      function requestUpdate() {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            updateSliders();
            ticking = false;
          });
          ticking = true;
        }
      }

      function updateSliders() {
        try {
          const c_val = $('#slider_input').val();
          const b_val = $('#slider_input_bright').val();

          $('#slider_thumb')
            .text(c_val)
            .css('left', c_val + '%');
          $('#slider_line').css('width', c_val + '%');

          $('#slider_thumb_bright')
            .text(b_val)
            .css('left', b_val + '%');
          $('#slider_line_bright').css('width', b_val + '%');

          if (window.halftone_image) {
            window.halftone_image.contrast = c_val / 100;
            window.halftone_image.brightness = b_val / 100;
            window.halftone_image.update();
          }
        } catch (error) {
          console.error('[Halftone] Render error:', error);
          $('.loading-img').addClass('hidden');
        }
      }

      // Event Listeners
      $('#slider_input, #slider_input_bright').on('input', requestUpdate);
      $('#custom-quantity').on('input', function() {
        updatePrice();
      });

      // Slider Plus/Minus Button Logic (CG-004)
      $('.halftone-slider-btn-minus, .halftone-slider-btn-plus').on('click', function () {
        const $btn = $(this);
        const sliderType = $btn.data('slider');
        const isMinus = $btn.hasClass('halftone-slider-btn-minus');

        const $input = sliderType === 'contrast' ? $('#slider_input') : $('#slider_input_bright');
        let currentVal = parseInt($input.val()) || 50;

        // Adjust by 5 units
        const newVal = isMinus ? Math.max(0, currentVal - 5) : Math.min(100, currentVal + 5);

        $input.val(newVal);
        requestUpdate();

        console.log(`[Halftone] ${sliderType} ${isMinus ? 'decreased' : 'increased'} to ${newVal}`);
      });

      // CG-01: Locked Aspect Ratio with 300 DPI px→cm conversion
      // 300 DPI = 118.11 pixels per centimeter (300 / 2.54)
      const PX_PER_CM_300DPI = 118.11;
      const MIN_SIZE_CM = 30;   // Mindestgröße in cm (CNC-Hardware-Beschränkung)
      const MAX_LONG_CM = 120;  // Längste Seite max (orientierungsbasiert)
      const MAX_SHORT_CM = 80;  // Kürzeste Seite max (orientierungsbasiert)

      let aspectRatioLocked = false;
      let aspectRatio = 1; // Will be calculated from uploaded image
      let imageLoaded = false;        // True after first image upload
      let currentCanvasWidth = 755;   // Tracks active canvas width for dot size calculation
      let currentCanvasHeight = 1133; // Tracks active canvas height for dot size calculation

      // Zuletzt berechnete Dimensionen (gesetzt von updatePrice, gelesen von Add-to-Cart)
      // Verhindert Race-Condition wenn DOM-Werte zwischen Berechnung und Submit zurückgesetzt werden
      let lastWidth = 40;
      let lastHeight = 40;

      // v4: Original-Upload des Kunden (wird mit der Bestellung gespeichert)
      let originalFile = null;

      /**
       * Begrenzt Dimensionen: Min 30cm je Seite, Max orientierungsbasiert (120/80).
       * Preserviert KEIN Seitenverhältnis — Caller ist dafür zuständig.
       */
      function clampDimensions(w, h) {
        w = Math.max(MIN_SIZE_CM, parseFloat(w.toFixed(1)));
        h = Math.max(MIN_SIZE_CM, parseFloat(h.toFixed(1)));
        if (w >= h) {
          w = Math.min(w, MAX_LONG_CM);
          h = Math.min(h, MAX_SHORT_CM);
        } else {
          w = Math.min(w, MAX_SHORT_CM);
          h = Math.min(h, MAX_LONG_CM);
        }
        return { w, h };
      }

      // Lock button – nach Image-Upload aktiv und umschaltbar
      const $lockBtn = $('#size-ratio-lock');
      $lockBtn.prop('disabled', true);
      $lockBtn.attr('title', 'Seitenverhältnis wird automatisch beim Upload gesperrt');

      /**
       * Setzt das Seitenverhältnis aus den Bild-Dimensionen und sperrt es initial.
       * @param {number} imageWidth - Bildbreite in Pixeln
       * @param {number} imageHeight - Bildhöhe in Pixeln
       * @returns {Object} - { widthCm, heightCm }
       */
      function lockAspectRatioFromImage(imageWidth, imageHeight) {
        aspectRatio = imageWidth / imageHeight;
        aspectRatioLocked = true;

        // Lock-Button visuell aktiv schalten (nicht toggle-bar, nur Anzeige)
        $lockBtn.addClass('is-locked');
        $lockBtn.prop('disabled', true);
        $lockBtn.css({ opacity: '1', cursor: 'default', color: '#70BE6E' });

        // Tooltip: vereinfachtes Verhältnis (z.B. "4:3")
        var rGcd = function(a, b) { return b ? rGcd(b, a % b) : a; };
        var rW = Math.round(imageWidth);
        var rH = Math.round(imageHeight);
        var d = rGcd(rW, rH);
        var simpleW = rW / d;
        var simpleH = rH / d;
        if (simpleW > 50 || simpleH > 50) {
          $lockBtn.attr('title', 'Seitenverhältnis gesperrt (' + aspectRatio.toFixed(1) + ':1)');
        } else {
          $lockBtn.attr('title', 'Seitenverhältnis gesperrt (' + simpleW + ':' + simpleH + ')');
        }

        // Pixel → cm bei 300 DPI (eine Dezimalstelle)
        const widthCm = parseFloat((imageWidth / PX_PER_CM_300DPI).toFixed(1));
        const heightCm = parseFloat((imageHeight / PX_PER_CM_300DPI).toFixed(1));

        console.log('[Halftone CG-01] Aspect ratio locked from image:', {
          ratio: aspectRatio.toFixed(2),
          imagePx: imageWidth + 'x' + imageHeight,
          imageCm: widthCm + 'x' + heightCm,
        });

        return { widthCm, heightCm };
      }

      // Lock-Button: Seitenverhältnis dauerhaft gesperrt (kein Toggle möglich)
      // Das Verhältnis wird beim Upload gesetzt und bleibt fix.

      // Seitenverhältnis-Handler: 'change' statt 'input' verhindert Flackern beim Tippen
      $('#custom-height, #custom-width').on('change', function () {
        if (!aspectRatioLocked) {
          updatePrice();
          return;
        }

        const $input = $(this);
        const isHeight = $input.attr('id') === 'custom-height';
        const newValue = parseFloat($input.val()) || 40;

        if (isHeight) {
          const newWidth = parseFloat((newValue * aspectRatio).toFixed(1));
          $('#custom-width').val(newWidth);
          console.log('[Halftone CG-01] Auto-adjusted width to', newWidth, 'cm');
        } else {
          const newHeight = parseFloat((newValue / aspectRatio).toFixed(1));
          $('#custom-height').val(newHeight);
          console.log('[Halftone CG-01] Auto-adjusted height to', newHeight, 'cm');
        }

        updatePrice();
      });

      // Min/Max erzwingen wenn User das Feld verlässt (orientierungsbasiert)
      $('#custom-height, #custom-width').on('blur', function () {
        let w = parseFloat($('#custom-width').val()) || MIN_SIZE_CM;
        let h = parseFloat($('#custom-height').val()) || MIN_SIZE_CM;

        if (aspectRatioLocked) {
          const $input = $(this);
          const isHeight = $input.attr('id') === 'custom-height';
          if (isHeight) {
            h = parseFloat($input.val()) || MIN_SIZE_CM;
            w = parseFloat((h * aspectRatio).toFixed(1));
          } else {
            w = parseFloat($input.val()) || MIN_SIZE_CM;
            h = parseFloat((w / aspectRatio).toFixed(1));
          }
        }

        const clamped = clampDimensions(w, h);

        if (w !== clamped.w || h !== clamped.h) {
          console.log('[Halftone] Dimensionen korrigiert:', Math.round(w) + 'x' + Math.round(h), '->', clamped.w + 'x' + clamped.h);
          $('#custom-width').val(clamped.w);
          $('#custom-height').val(clamped.h);
          updatePrice();
        }
      });

      // Upload Logic
      $('#trigger_upload').on('click', () => $('#source_file').click());

      // Image Replace Button Handler (wirestyle.com style)
      $('#replace-image-btn').on('click', function() {
        console.log('[Halftone] Replace image button clicked');
        $('#source_file').click();
      });

      // Drag and Drop Logic - EVENT DELEGATION
      // Verwende Event Delegation auf document.body für robustes Handling
      // auch wenn Elemente später ins DOM kommen oder display:none sind

      function handleDragOver(e) {
        // Prüfe ob das Event innerhalb unserer Drop-Zone ist
        const $target = $(e.target);
        if ($target.closest('.halftone-image-placeholder').length === 0) {
          return; // Nicht unsere Zone
        }

        e.preventDefault();
        e.stopPropagation();
        $('.halftone-image-placeholder').addClass('drag-over');
        console.log('[Halftone] Drag over detected');
      }

      function handleDragLeave(e) {
        const $target = $(e.target);
        if ($target.closest('.halftone-image-placeholder').length === 0) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();

        // Nur entfernen wenn wir wirklich die Zone verlassen
        const $dropZone = $('.halftone-image-placeholder');
        if ($dropZone.length === 0) return;

        const rect = $dropZone[0].getBoundingClientRect();
        const x = e.originalEvent ? e.originalEvent.clientX : e.clientX;
        const y = e.originalEvent ? e.originalEvent.clientY : e.clientY;

        if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
          $dropZone.removeClass('drag-over');
          console.log('[Halftone] Drag leave - outside zone');
        }
      }

      function handleDrop(e) {
        const $target = $(e.target);
        if ($target.closest('.halftone-image-placeholder').length === 0) {
          return;
        }

        e.preventDefault();
        e.stopPropagation();
        $('.halftone-image-placeholder').removeClass('drag-over');

        const dataTransfer = e.originalEvent ? e.originalEvent.dataTransfer : e.dataTransfer;
        const files = dataTransfer ? dataTransfer.files : null;

        if (files && files.length > 0) {
          const file = files[0];
          console.log('[Halftone] Drop detected:', file.name, file.type);

          // Validate file type
          if (!file.type.match('image.*')) {
            alert('Bitte wählen Sie ein gültiges Bild aus.');
            console.error('[Halftone] Invalid file type:', file.type);
            return;
          }

          // Process dropped file directly via URL.createObjectURL
          // (input.files = files is read-only in most browsers)
          processDroppedFile(file);
        } else {
          console.warn('[Halftone] No files in drop event');
        }
      }

      /**
       * Process a dropped file directly — bypasses input.files security restriction.
       * Mirrors the logic in the #source_file change handler.
       */
      function processDroppedFile(file) {
        console.log('[Halftone] Processing dropped file:', file.name);
        originalFile = file;
        $('.loading-img').removeClass('hidden');

        try {
          const img = new Image();
          img.src = URL.createObjectURL(file);

          img.onload = function () {
            console.log('[Halftone] Dropped image loaded:', img.width, 'x', img.height);

            if (!window.halftone_image) {
              console.error('[Halftone] RasterPro not ready!');
              $('.loading-img').addClass('hidden');
              return;
            }

            // Canvas dimensions from image aspect ratio
            // CG-03: Resolution configurable via Theme Settings > Halftone Picture Price Settings
            const maxCanvasSize = (window.halftoneThemeSettings && window.halftoneThemeSettings.previewResolution) || 2400;
            let newWidth, newHeight;
            if (img.width >= img.height) {
              newWidth = maxCanvasSize;
              newHeight = Math.round(maxCanvasSize * (img.height / img.width));
            } else {
              newHeight = maxCanvasSize;
              newWidth = Math.round(maxCanvasSize * (img.width / img.height));
            }

            console.log('[Halftone] Target canvas:', newWidth, 'x', newHeight);

            // Update RasterPro
            window.halftone_image.canvasWidth = newWidth;
            window.halftone_image.canvasHeight = newHeight;
            normalizeSourceImage(img, newWidth, newHeight).then(function(normalizedImg) {
            window.halftone_image.sourceImage = normalizedImg;
            imageLoaded = true;
            currentCanvasWidth = newWidth;
            currentCanvasHeight = newHeight;

            // DOT_SIZE aus Theme Settings (mm → px, fixe Skalierung 4 px/mm)
            window.halftone_image.dotSize = Math.max(2, (themeSettings.dotSize || 2) * 4);
            console.log('[Halftone] DOT_SIZE (from theme, mm→px):', window.halftone_image.dotSize, 'px');

            // Show canvas, hide drop box
            const $placeholder = $('.halftone-image-placeholder');
            $placeholder.addClass('has-image');
            $('.drop_box').hide();

            const $rasterWrapper = $('#raster_pro_wrapper');
            $rasterWrapper.css({
              opacity: '1',
              visibility: 'visible',
              display: 'block',
            });

            // Force canvas visible after short delay
            setTimeout(function () {
              $rasterWrapper.find('canvas').each(function () {
                this.style.setProperty('display', 'block', 'important');
                this.style.setProperty('visibility', 'visible', 'important');
                this.style.setProperty('opacity', '1', 'important');
                this.style.setProperty('position', 'relative', 'important');
              });
              console.log('[Halftone] Canvas forced visible after drop');
            }, 200);

            // Seitenverhältnis aus Bild sperren (Auflösung/DPI irrelevant)
            lockAspectRatioFromImage(img.width, img.height);

            // Aktuelle Eingabewerte beibehalten, Seitenverhältnis + Min/Max anpassen
            let cmW = Math.max(MIN_SIZE_CM, parseFloat($('#custom-width').val()) || 40);
            let cmH = parseFloat((cmW / aspectRatio).toFixed(1));

            // Min enforcement
            if (cmH < MIN_SIZE_CM) { cmH = MIN_SIZE_CM; cmW = parseFloat((cmH * aspectRatio).toFixed(1)); }

            // Max enforcement (orientierungsbasiert, mit Ratio-Erhalt)
            if (Math.max(cmW, cmH) > MAX_LONG_CM) {
              if (cmW >= cmH) { cmW = MAX_LONG_CM; cmH = parseFloat((cmW / aspectRatio).toFixed(1)); }
              else { cmH = MAX_LONG_CM; cmW = parseFloat((cmH * aspectRatio).toFixed(1)); }
            }
            if (Math.min(cmW, cmH) > MAX_SHORT_CM) {
              if (cmW <= cmH) { cmW = MAX_SHORT_CM; cmH = parseFloat((cmW / aspectRatio).toFixed(1)); }
              else { cmH = MAX_SHORT_CM; cmW = parseFloat((cmH * aspectRatio).toFixed(1)); }
            }
            cmW = Math.max(MIN_SIZE_CM, cmW);
            cmH = Math.max(MIN_SIZE_CM, cmH);

            console.log('[Halftone] Dimensionen (Ratio aus Bild, Größe aus Eingabe):', cmW + 'x' + cmH + ' cm');

            $('#custom-width').val(cmW);
            $('#custom-height').val(cmH);

            // Store base64 for cart (same as change handler)
            // CG-03: Increased JPEG quality from 60% to 80%
            try {
              const tempCanvas = document.createElement('canvas');
              tempCanvas.width = Math.min(img.width, 400);
              tempCanvas.height = Math.round(tempCanvas.width * (img.height / img.width));
              const ctx = tempCanvas.getContext('2d');
              ctx.drawImage(img, 0, 0, tempCanvas.width, tempCanvas.height);
              const base64 = tempCanvas.toDataURL('image/jpeg', 0.8);
              $('#input_image_hidden').attr('data-lineitemimg', base64);
              console.log('[Halftone] Base64 stored:', Math.round(base64.length / 1024), 'KB');
            } catch (b64err) {
              console.warn('[Halftone] Base64 conversion failed:', b64err.message);
            }

            // Update price
            if (typeof updatePrice === 'function') {
              updatePrice();
            }

            // Hide loading
            setTimeout(function () {
              $('.loading-img').addClass('hidden');
            }, 500);

            console.log('[Halftone] Drop processing complete ✅');
            }); // normalizeSourceImage
          };

          img.onerror = function () {
            console.error('[Halftone] Failed to load dropped image');
            $('.loading-img').addClass('hidden');
            alert('Das Bild konnte nicht geladen werden.');
          };
        } catch (err) {
          console.error('[Halftone] Drop processing error:', err);
          $('.loading-img').addClass('hidden');
        }
      }

      // Event Delegation auf document - funktioniert immer, auch bei SSR
      $(document).on('dragover', handleDragOver);
      $(document).on('dragenter', handleDragOver);
      $(document).on('dragleave', handleDragLeave);
      $(document).on('drop', handleDrop);

      // MUST preventDefault on document-level dragover to allow drop
      // Without this, the browser blocks the drop entirely
      $(document).on('dragover', function (e) {
        e.preventDefault();
      });

      console.log('[Halftone] Drag & Drop event delegation initialized');

      $('#source_file').on('change', function (e) {
        console.log('[Halftone CG-003] File selected:', e.target.files[0]?.name);
        const file = e.target.files[0];
        if (!file) {
          console.warn('[Halftone CG-003] No file selected');
          return;
        }

        // Security: Validate file type
        if (!file.type.match('image.*')) {
          alert('Bitte wählen Sie ein gültiges Bild aus.');
          console.error('[Halftone CG-003] Invalid file type:', file.type);
          return;
        }

        console.log('[Halftone CG-003] Valid image file, starting upload...');
        originalFile = file;
        $('.loading-img').removeClass('hidden');

        try {
          const img = new Image();
          img.src = URL.createObjectURL(file);

          img.onload = function () {
            console.log('[Halftone CG-003] Image loaded successfully:', img.width, 'x', img.height);

            if (window.halftone_image) {
              console.log('[Halftone CG-003] RasterPro instance found, updating source image...');

              // Adapt canvas dimensions to actual image aspect ratio
              const imgWidth = img.width;
              const imgHeight = img.height;
              // CG-03: Resolution configurable via Theme Settings > Halftone Picture Price Settings
              const maxCanvasSize = (window.halftoneThemeSettings && window.halftoneThemeSettings.previewResolution) || 2400;

              let newWidth, newHeight;
              if (imgWidth >= imgHeight) {
                // Landscape or square
                newWidth = maxCanvasSize;
                newHeight = Math.round(maxCanvasSize * (imgHeight / imgWidth));
              } else {
                // Portrait
                newHeight = maxCanvasSize;
                newWidth = Math.round(maxCanvasSize * (imgWidth / imgHeight));
              }

              console.log('[Halftone CG-003] Target canvas size:', newWidth, 'x', newHeight);

              // Update RasterPro settings
              window.halftone_image.canvasWidth = newWidth;
              window.halftone_image.canvasHeight = newHeight;
              normalizeSourceImage(img, newWidth, newHeight).then(function(normalizedImg) {
              window.halftone_image.sourceImage = normalizedImg;
              imageLoaded = true;
              currentCanvasWidth = newWidth;
              currentCanvasHeight = newHeight;

              // DOT_SIZE aus Theme Settings (mm → px, fixe Skalierung 4 px/mm)
              window.halftone_image.dotSize = Math.max(2, (themeSettings.dotSize || 2) * 4);
              console.log('[Halftone] DOT_SIZE (from theme, mm→px):', window.halftone_image.dotSize, 'px');

              // Add has-image class to hide drop box and show canvas
              const $placeholder = $('.halftone-image-placeholder');
              $placeholder.addClass('has-image');

              // Hide the drop box explicitly
              $('.drop_box').hide();

              // Force visibility of the wrapper
              const $rasterWrapper = $('#raster_pro_wrapper');
              $rasterWrapper.css({
                opacity: '1',
                visibility: 'visible',
                display: 'block',
              });

              // Helper function to force canvas visibility
              function forceCanvasVisible() {
                const $canvas = $rasterWrapper.find('canvas');
                if ($canvas.length > 0) {
                  // Override RasterPro's inline styles
                  $canvas.each(function () {
                    this.style.setProperty('display', 'block', 'important');
                    this.style.setProperty('visibility', 'visible', 'important');
                    this.style.setProperty('opacity', '1', 'important');
                    this.style.setProperty('position', 'relative', 'important');
                  });
                  console.log(
                    '[Halftone CG-003] Canvas forced visible:',
                    $canvas[0].width,
                    'x',
                    $canvas[0].height
                  );
                  return true;
                }
                return false;
              }

              // Force re-render
              try {
                window.halftone_image.update();
                console.log('[Halftone CG-003] RasterPro update() called successfully');
              } catch (renderError) {
                console.error('[Halftone CG-003] RasterPro render error:', renderError);
              }

              // Force canvas visible immediately
              forceCanvasVisible();

              // Also force visibility after RasterPro's async rendering completes
              // RasterPro renders asynchronously, so we need to keep checking
              let attempts = 0;
              const maxAttempts = 20;
              const checkInterval = setInterval(function () {
                attempts++;
                forceCanvasVisible();

                if (attempts >= maxAttempts) {
                  clearInterval(checkInterval);
                  console.log(
                    '[Halftone CG-003] Canvas visibility check complete after',
                    attempts,
                    'attempts'
                  );
                }
              }, 100);

              // Seitenverhältnis aus Bild sperren (Auflösung/DPI irrelevant)
              lockAspectRatioFromImage(imgWidth, imgHeight);

              // Aktuelle Eingabewerte beibehalten, Seitenverhältnis + Min/Max anpassen
              let cmW = Math.max(MIN_SIZE_CM, parseFloat($('#custom-width').val()) || 40);
              let cmH = parseFloat((cmW / aspectRatio).toFixed(1));

              // Min enforcement
              if (cmH < MIN_SIZE_CM) { cmH = MIN_SIZE_CM; cmW = parseFloat((cmH * aspectRatio).toFixed(1)); }

              // Max enforcement (orientierungsbasiert, mit Ratio-Erhalt)
              if (Math.max(cmW, cmH) > MAX_LONG_CM) {
                if (cmW >= cmH) { cmW = MAX_LONG_CM; cmH = parseFloat((cmW / aspectRatio).toFixed(1)); }
                else { cmH = MAX_LONG_CM; cmW = parseFloat((cmH * aspectRatio).toFixed(1)); }
              }
              if (Math.min(cmW, cmH) > MAX_SHORT_CM) {
                if (cmW <= cmH) { cmW = MAX_SHORT_CM; cmH = parseFloat((cmW / aspectRatio).toFixed(1)); }
                else { cmH = MAX_SHORT_CM; cmW = parseFloat((cmH * aspectRatio).toFixed(1)); }
              }
              cmW = Math.max(MIN_SIZE_CM, cmW);
              cmH = Math.max(MIN_SIZE_CM, cmH);

              console.log('[Halftone] Dimensionen (Ratio aus Bild, Größe aus Eingabe):', cmW + 'x' + cmH + ' cm');

              $('#custom-width').val(cmW);
              $('#custom-height').val(cmH);

              // Update price with new dimensions
              updatePrice();

              console.log(
                '[Halftone CG-003] Upload processing complete - has-image:',
                $placeholder.hasClass('has-image')
              );
              $('.loading-img').addClass('hidden');
              }); // normalizeSourceImage
            } else {
              console.error('[Halftone CG-003] RasterPro instance NOT found!');
              $('.loading-img').addClass('hidden');
            }
          };

          img.onerror = (err) => {
            console.error('[Halftone CG-003] Image load failed:', err);
            $('.loading-img').addClass('hidden');
          };
        } catch (err) {
          console.error('[Halftone CG-003] Upload processing error:', err);
          $('.loading-img').addClass('hidden');
        }
      });

      /**
       * Exportiert das gerenderte Halftone-Canvas als Base64 Data-URL
       * Das Canvas enthält das Bild MIT allen Einstellungen (Kontrast, Helligkeit, Raster-Effekt)
       * genau so wie der User es auf dem Bildschirm sieht.
       *
       * @returns {Object|null} - {dataUrl, blob} oder null wenn kein Canvas
       */
      function exportRenderedImage() {
        return new Promise((resolve) => {
          // RasterPro rendert in ein Canvas innerhalb von #raster_pro_wrapper
          // WICHTIG: Nicht das versteckte #resizer_canvas verwenden!
          const $wrapper = $('#raster_pro_wrapper');
          const $canvas = $wrapper.find('canvas:visible').first();

          // Fallback: Wenn kein sichtbares Canvas, nimm das erste im Wrapper
          const canvas = $canvas.length ? $canvas[0] : $wrapper.find('canvas').first()[0];

          if (!canvas) {
            console.warn('[Halftone v2] Kein Canvas gefunden - kein Bild hochgeladen');
            resolve(null);
            return;
          }

          // Log Canvas-Details für Debugging
          console.log('[Halftone v2] Exportiere Canvas:', {
            width: canvas.width,
            height: canvas.height,
            contrast: window.halftone_image?.contrast,
            brightness: window.halftone_image?.brightness,
          });

          try {
            // Canvas zu Data-URL konvertieren (Base64)
            // CG-04: Increased JPEG quality to 95% for higher-fidelity export output
            const dataUrl = canvas.toDataURL('image/jpeg', 0.95);

            // Auch als Blob für File-Upload
            // CG-03: Increased blob quality from 85% to 80% (matching dataUrl)
            canvas.toBlob(
              (blob) => {
                const sizeKB = Math.round((dataUrl.length * 0.75) / 1024);
                console.log('[Halftone v2] Canvas exportiert:', {
                  dataUrlSize: sizeKB + ' KB',
                  blobSize: blob ? Math.round(blob.size / 1024) + ' KB' : 'N/A',
                });

                // Warnung wenn zu groß für Shopify Property (max ~5KB empfohlen für Properties)
                if (sizeKB > 100) {
                  console.warn(
                    '[Halftone v2] Bild ist groß (' + sizeKB + ' KB). Verwende File-Upload.'
                  );
                }

                resolve({
                  dataUrl: dataUrl,
                  blob: blob,
                  sizeKB: sizeKB,
                });
              },
              'image/jpeg',
              0.95
            );
          } catch (err) {
            console.error('[Halftone v2] Canvas Export fehlgeschlagen:', err);
            resolve(null);
          }
        });
      }

      /**
       * Erstellt einen eindeutigen Dateinamen für das Bild
       */
      function generateImageFilename() {
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
        const random = Math.random().toString(36).substring(2, 8);
        return `halftone-${timestamp}-${random}.jpg`;
      }

      // Cart Integration (v4.0 - Preisstufen + Shopify-Datei-Upload)
      $('#custom_add_cart').on('click', async function () {
        const btn = $(this);
        btn.prop('disabled', true).text('WIRD VERARBEITET...');

        // Gespeicherte Werte aus updatePrice() verwenden statt DOM erneut zu lesen
        // Verhindert Bug: DOM-Reset durch Input-Handler setzt Werte auf 40x40 zurueck
        const w = lastWidth;
        const h = lastHeight;
        const q = parseInt($('#custom-quantity').val()) || 1;
        const area = w * h;

        // Min/Max-Validierung (Schutz gegen DevTools-Manipulation)
        if (w < MIN_SIZE_CM || h < MIN_SIZE_CM) {
          alert('Mindestgröße: ' + MIN_SIZE_CM + ' cm je Seite. Bitte Maße korrigieren.');
          btn.prop('disabled', false).text('ZUM WARENKORB HINZUFÜGEN');
          return;
        }
        if (Math.max(w, h) > MAX_LONG_CM || Math.min(w, h) > MAX_SHORT_CM) {
          alert('Maximalgröße: ' + MAX_LONG_CM + ' x ' + MAX_SHORT_CM + ' cm. Bitte Maße korrigieren.');
          btn.prop('disabled', false).text('ZUM WARENKORB HINZUFÜGEN');
          return;
        }

        // Prüfe ob ein Bild hochgeladen wurde
        const hasImage = $('.halftone-image-placeholder').hasClass('has-image');
        if (!hasImage) {
          alert('Bitte lade zuerst ein Bild hoch.');
          btn.prop('disabled', false).text('ZUM WARENKORB HINZUFÜGEN');
          return;
        }

        // === v4: Bild exportieren ===
        btn.text('BILD WIRD VERARBEITET...');
        const imageData = await exportRenderedImage();

        if (!imageData || !imageData.blob) {
          alert('Fehler beim Verarbeiten des Bildes. Bitte versuche es erneut.');
          btn.prop('disabled', false).text('ZUM WARENKORB HINZUFÜGEN');
          return;
        }

        // === v4: Preisstufe bestimmen ===
        const tier = findTier(w, h);
        if (!tier) {
          alert('Preisstufe nicht gefunden. Bitte kontaktiere uns kurz per WhatsApp.');
          btn.prop('disabled', false).text('ZUM WARENKORB HINZUFÜGEN');
          return;
        }

        // === v4: Zum Warenkorb hinzufügen, Bilder als Shopify-Dateien ===
        btn.text('BILD WIRD HOCHGELADEN...');

        const contrastVal = $('#slider_input').val();
        const brightnessVal = $('#slider_input_bright').val();
        const renderSettings = JSON.stringify({
          contrast: contrastVal,
          brightness: brightnessVal,
          rasterType: 'line',
          rasterAngle: 30, // KARVA: Fräswinkel immer 30°
          dotSize: 10,
          canvasWidth: window.halftone_image?.canvasWidth || 'unknown',
          canvasHeight: window.halftone_image?.canvasHeight || 'unknown',
        });

        function buildFormData(withOriginal, original) {
          const fd = new FormData();
          fd.append('id', tier.id);
          fd.append('quantity', q);
          fd.append('properties[Größe]', w + 'x' + h + ' cm');
          fd.append('properties[Kontrast]', contrastVal + '%');
          fd.append('properties[Helligkeit]', brightnessVal + '%');
          fd.append('properties[_Fläche]', Math.round(area) + ' cm²');
          fd.append('properties[_Render-Settings]', renderSettings);
          fd.append('properties[Vorschaubild]', imageData.blob, generateImageFilename());
          if (withOriginal && original) {
            fd.append('properties[_Originalbild]', original.blob, original.name);
          }
          return fd;
        }

        function postToCart(fd) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: fd,
          }).then(function (response) {
            if (!response.ok) {
              return response.json().catch(function () { return {}; }).then(function (err) { return Promise.reject(err); });
            }
            return response.json();
          });
        }

        const original = await prepareOriginal(originalFile);
        console.log('[Halftone v4] Adding to cart:', {
          variantId: tier.id,
          tierMax: tier.max + ' cm²',
          price: (tier.price / 100).toFixed(2) + '€',
          size: w + 'x' + h,
          hasOriginal: !!original,
        });

        postToCart(buildFormData(true, original))
          .catch(function (err) {
            // Zweiter Versuch ohne Originalfoto (z. B. falls die Datei zu groß ist)
            if (!original) return Promise.reject(err);
            console.warn('[Halftone v4] Upload mit Original fehlgeschlagen, versuche ohne:', err);
            return postToCart(buildFormData(false, null));
          })
          .then(function (response) {
            console.log('[Halftone v4] Cart success:', response);
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.error('[Halftone v4] Cart error:', err);
            const errorMsg = (err && (err.description || err.message)) || 'Unbekannter Fehler';
            alert('Fehler beim Hinzufügen zum Warenkorb: ' + errorMsg);
            btn.prop('disabled', false).text('ZUM WARENKORB HINZUFÜGEN');
          });
      });

      /**
       * v4: Originalfoto für den Upload vorbereiten.
       * Sehr große Dateien (> 15 MB) oder ungewöhnliche Formate (z. B. HEIC)
       * werden als JPEG mit max. 6000 px neu erzeugt.
       */
      function prepareOriginal(file) {
        return new Promise(function (resolve) {
          if (!file) { resolve(null); return; }
          const direct = /^image\/(jpeg|png|webp)$/.test(file.type) && file.size <= 15 * 1024 * 1024;
          const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
          if (direct) {
            const ext = file.type === 'image/png' ? 'png' : file.type === 'image/webp' ? 'webp' : 'jpg';
            resolve({ blob: file, name: 'original-' + ts + '.' + ext });
            return;
          }
          const url = URL.createObjectURL(file);
          const img = new Image();
          img.onload = function () {
            const s = Math.min(1, 6000 / Math.max(img.naturalWidth, img.naturalHeight));
            const c = document.createElement('canvas');
            c.width = Math.round(img.naturalWidth * s);
            c.height = Math.round(img.naturalHeight * s);
            const ctx = c.getContext('2d');
            ctx.fillStyle = '#ffffff';
            ctx.fillRect(0, 0, c.width, c.height);
            ctx.drawImage(img, 0, 0, c.width, c.height);
            c.toBlob(function (b) {
              URL.revokeObjectURL(url);
              resolve(b ? { blob: b, name: 'original-' + ts + '.jpg' } : null);
            }, 'image/jpeg', 0.92);
          };
          img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
          img.src = url;
        });
      }

      // Initial Call
      updatePrice();
    });
  }

  init();
})();
